import useKintStore from '~kint/store';
import { useLayoutEffect } from 'react';

export default function useSyncReservation() {
  const { syncReservation } = useKintStore((state) => ({ syncReservation: state.syncReservation }));
  useLayoutEffect(() => {
    syncReservation();
  }, [syncReservation]);
}
